
'use strict';

import SerpUrl from '../url/index.js';

class PySerpQuery {

    constructor(config) {
        this.config = config;
        this.serpUrl = new SerpUrl();
    }

    get category() {
        return this.config.category;
    }

    get query() {
        return this.config.queryTerms;
    }

    get clickTrackingUrl() {
        return `${this.config.clickUrl}?${this.config.clickParams}`;
    }

    get signature() {
        return this.config.signature;
    }

    get isTest() {
        if(this.config.testMode) {
            return true;
        } else {
            return undefined;
        }
    }

    get domain() {
        return this.config.domain || 'search.pch.com';
    }

    get segment() {
        return this.config.segment;
    }

    get partnerId() {
        return this.config.partnerId || 40983;
    }

}

export default PySerpQuery;
